import { render, staticRenderFns } from "./ConsultantDetail.vue?vue&type=template&id=2b1b4947&lang=html&"
import script from "./ConsultantDetail.vue?vue&type=script&lang=coffee&"
export * from "./ConsultantDetail.vue?vue&type=script&lang=coffee&"
import style0 from "./ConsultantDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ConsultantDetail.vue"
export default component.exports